import { render, staticRenderFns } from "./NewAiRobotDetails.vue?vue&type=template&id=17037ddd&"
import script from "./NewAiRobotDetails.vue?vue&type=script&lang=js&"
export * from "./NewAiRobotDetails.vue?vue&type=script&lang=js&"
import style0 from "./NewAiRobotDetails.vue?vue&type=style&index=0&id=17037ddd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports